/**
 * CDN Origin Error Logs
 *
 * Contact: daniel@bunny.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const ErrorCode = {
  dns_lookup: 'dns_lookup',
  error: 'error',
  http_invalid_compression: 'http_invalid_compression',
  http_invalid_range: 'http_invalid_range',
  http_loop_detected: 'http_loop_detected',
  http_request_exception: 'http_request_exception',
  http_request_failure: 'http_request_failure',
  http_timeout: 'http_timeout',
  network_io_error: 'network_io_error',
  network_socket_exception: 'network_socket_exception',
  notfound_localdb: 'notfound_localdb',
} as const;
export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];
